import { useMemo } from 'react';

import { SelectItem } from '@/types/ui';
import { ScoreData } from '../PartnerScoreDataAvailabilityTypes/PartnerScoreDataAvailabilitytypes';
import { getAllYearQuarters, getUserCountries, getYearsWithData } from './getDataTransformations';

interface DataAvailabilityColumns {
  allYearQuarters: ReturnType<typeof getAllYearQuarters>;
  userCountries: ReturnType<typeof getUserCountries>;
}

/**
 * Derives the year columns and the country rows for the availability table.
 * Year columns come from the availability records themselves so the timeline
 * only shows years that actually have data (work item #5283).
 */
export const useDataAvailabilityColumns = (
  allPartnerScores: ScoreData[],
  userCountriesData: SelectItem[],
): DataAvailabilityColumns => {
  const allYearQuarters = useMemo(() => getAllYearQuarters(getYearsWithData(allPartnerScores)), [allPartnerScores]);

  const userCountries = useMemo(
    () =>
      getUserCountries(
        userCountriesData.map(country => ({
          label: country?.label?.toString(),
          value: country?.value?.toString(),
        })),
      ),
    [userCountriesData],
  );

  return { allYearQuarters, userCountries };
};
